import React from "react";

const ErrorIcon = ({className = "", restProps}) => {
  return (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"
           className={className}
           {...restProps}
      >
        <path
            d="M13.134 1.5C13.5189 0.833333 14.4811 0.833333 14.866 1.5L25.2583 19.5C25.6432 20.1667 25.1621 21 24.3923 21H3.60769C2.83789 21 2.35677 20.1667 2.74167 19.5L13.134 1.5Z"
            stroke="white" strokeWidth="2"/>
        <path d="M14 10V14" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="14" cy="17" r="1" fill="white"/>
      </svg>
  )
};

export default ErrorIcon
